import {combineReducers} from 'redux';

import {authentication} from './authentication.reducer';
import {registration} from './registration.reducer';
import {users} from './users.reducer';
import {alert} from './alert.reducer';
import {middleware} from './middleware.reducer';

const rootReducer = combineReducers({
    authentication,
    registration,
    users,
    alert,
    middleware
});

export default rootReducer;